import React from 'react'
import { connect } from "react-redux";
import styled, { injectGlobal, css } from 'styled-components'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

import { themes, blue } from '../../styles/themes'
import { container, heading, bgImage, button, bgIcon } from "../../styles/global"
import { media, isClient } from "../../styles/utils";

import { fetchSettings, getSettings, updateSettings } from '../../store/settings';

import logo from '../../assets/images/logo.png'

class Splash extends React.Component {

	state = {
		splashTheme: blue,
		splashActive: false,
	}
	
	componentWillMount = () => {
		const { location, updateSettings } = this.props;

		if (isClient()) {
			let container = document.getElementById('splashContainer')
			let header = document.getElementById('header')

			if (sessionStorage.getItem('introSeen') || location.pathname === '/casestudy/') { 			
				this.setState({
					splashActive: false
				})
				
				if (container) {
					container.classList.add('transition')
					container.classList.remove('active')
					header.classList.add('active')
				}

				enableBodyScroll()
				// document.body.style.overflow = 'auto';
			} else {

				this.setState({
					splashActive: true
				})

				if (container) {
					container.classList.add('active');
					header.classList.remove('active')
				}

				disableBodyScroll()
				// document.body.style.overflow = 'hidden';
			}
		}
	}
	
    componentDidMount = () => {     
		const { updateSettings } = this.props;

		window.addEventListener('mousewheel', this.seenSplash)
		window.addEventListener('touchstart', this.seenSplash)

		if (sessionStorage.getItem('introSeen') || location.pathname === '/casestudy/') {
			updateSettings({
				splashActive: false
			})
		}

		this.timer = setInterval(
            this.seenSplash,
            5000,
        )
	}
		
    componentDidUpdate = (prevProps, prevState) => {
		const { updateSettings } = this.props;
		const { splashActive } = this.state;

		console.log('componentDidUpdate')

		if (this.props.location.pathname !== '/casestudy/') {
			if (splashActive) {
				disableBodyScroll() 
			} else {
				setTimeout(() => {
					enableBodyScroll();
				}, 1000);
			}
		}

		if (prevState.splashActive !== this.state.splashActive) {			
			let container = document.getElementById('splashContainer')
			let header = document.getElementById('header')
			
			updateSettings({
				splashActive: this.state.splashActive
			})
			
			if (splashActive) {
				container.classList.remove('transition')
				container.classList.add('active')
				header.classList.remove('active')
			} else {
				container.classList.add('transition')
				container.classList.remove('active')
				header.classList.add('active')

				setTimeout(() => {
					enableBodyScroll();
					clearAllBodyScrollLocks();
					// document.body.style.overflow = 'auto';
				}, 1000);
			}
		}
	}
    
    componentWillUnmount() {
		window.removeEventListener('mousewheel', this.seenSplash);
		window.removeEventListener('touchstart', this.seenSplash)
        clearInterval(this.timer);
    }

	seenSplash = () => {
       if (this.state.splashActive) {
			sessionStorage.setItem('introSeen', true);
			window.removeEventListener('mousewheel', this.seenSplash);
			window.removeEventListener('touchstart', this.seenSplash)
			clearInterval(this.timer);

			this.setState({
				splashActive: false
			})
	   }
	}
    
    renderSplash = () => {
		const { splashActive, splashTheme } = this.state;

		return (
			<div
				id={'splashContainer'}
				onClick={this.seenSplash}
				theme={splashTheme}
			>
				<Container>
					<Logo/>
				</Container>
			</div>
		)
	}
	
	render() {
		return (
			<React.Fragment>
                {this.renderSplash()}                
			</React.Fragment>
		)
	}
}


const Container = styled.div`
    ${container}
	display: flex;
	flex-direction: column;
`

const Heading = styled.div`
	${heading}
`

injectGlobal`
	#splashContainer {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgb(228, 231, 235);
		z-index: 13;
		display: flex;
		justify-content: center;

		${Container} {
			height: 100%;
			justify-content: center;
			align-items: center;
		}

		/* Animation */

		opacity: 0;
		pointer-events: none;
	
		&.active {
			opacity: 1;
			pointer-events: all;
		}

		&.transition {
			transition: opacity 0.75s ease-out;
		}
	}
`

const SplashContainer = styled.div`

	${props => {
		if (props.active) return css`
			opacity: 1;
			pointer-events: all;
		`
	}}

	/* Theme */

	${props => {
		if (props.theme) {
			const theme = themes[props.theme];
			if (theme) {
				return css`
					background: ${theme.background};

					${Heading} {
						color: ${theme.text}
					}
				`
			}
		}
	}}
`

const Logo = styled.div`
	background-image: url(${logo});
	width: 374px;
	height: 40px;
	${bgIcon}

	${media.tablet`
		height: 30px;
	`}
`

const mapDispatchToProps = dispatch => ({
    fetchSettings() {
        dispatch(fetchSettings())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    settings: state.settings.settings
})

export default connect(mapStateToProps, mapDispatchToProps)(Splash);


// WEBPACK FOOTER //
// ./src/components/Splash/Splash.js